export default __webpack_public_path__ + "static/media/P308a.9ba5816e.mp3";